// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fgop","rootNoMargin":"styles_rootNoMargin__2s1XN"};